export const MY_SUBCRIPTIONS_URL_KEYS = {
  SUBCRIPTION_DETAILS: "SUBCRIPTION_DETAILS",
};

export const MY_SUBCRIPTIONS_ROUTE_IDS = {
  [MY_SUBCRIPTIONS_URL_KEYS.SUBCRIPTION_DETAILS]:
    "/business/credits/feature/subscription/view/paginated",
};
